"use client";

import { CarouselTabItem, CarouselTabs } from "@/components/common/carousel-tabs";
import { useAuth } from "@/hooks/use-auth";
import { useRouter } from "next/navigation";
import React, { useState } from "react";

export function FAQClient({
	tab = "buyer",
	tabs,
	asPrimaryHeading = false,
}: {
	tab: string;
	tabs: CarouselTabItem[];
	asPrimaryHeading?: boolean;
}) {
	const [currentTab, setCurrentTab] = useState<string>(tab);
	const router = useRouter();
	const { user } = useAuth();

	const name = user?.name && user.name !== "<No Name>" ? user.name : "Guest";

	// Sync currentTab with tab prop if it changes
	React.useEffect(() => {
		setCurrentTab(tab);
	}, [tab]);

	const handleTabChange = (key: React.Key) => {
		const tabKey = key.toString();
		setCurrentTab(tabKey);
		router.push(`/faq/${tabKey}`);
	};

	if (!tabs?.length) return null;

	return (
		<>
			<div className="text-center mb-12">
				{(() => {
					const HeadingTag: React.ElementType = asPrimaryHeading ? "h1" : "h2";
					return <HeadingTag className="text-4xl font-bold mb-6">{name}, Curious?</HeadingTag>;
				})()}
				<p className="text-lg text-gray-600 max-w-3xl mx-2">
					Find answers to common questions about our real estate services. Can&apos;t find what you&apos;re looking for?
					Contact us directly.
				</p>
			</div>

			{tabs.length > 1 ? (
				<CarouselTabs
					tabs={tabs}
					selectedKey={currentTab}
					variant="pills"
					size="md"
					className="mb-8"
					onSelectionChange={handleTabChange}
				/>
			) : (
				tabs[0].content
			)}
		</>
	);
}
